<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="3">
        <v-date-picker v-model="selectedDate" />
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col>
            <v-text-field
              v-model="search"
              :label="$t('project.search')"
              single-line
              hide-details
              clearable
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <v-data-table
                :headers="headers"
                :items="dataLicense"
                :page.sync="page"
                :search="search"
                :items-per-page="itemsPerPage"
                hide-default-footer
                @page-count="pageCount = $event"
              />
              <div class="text-center pt-2">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

// Libs
const moment = require("moment");

export default {
  components: {
    //
  },
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      selectedDate: moment(moment().toDate("YYYY-MM-DD")).format("YYYY-MM-DD"),
      page: 1,
      search: "",
      pageCount: 0,
      itemsPerPage: 10,
      dataLicense: [],
      headers: [
        { text: this.$t("akito.account-name"), value: "name_soc" },
        { text: this.$t("status.players"), value: "name_plyr" },
        { text: this.$t("akito.date-expire"), value: "dt_expire" },
      ],
    };
  },
  watch: {
    selectedDate: function (val) {
      if (val !== undefined) {
        this.listExpiredLicense(val);
      }
    },
  },
  created() {
    this.listExpiredLicense(this.selectedDate);
  },
  methods: {
    listExpiredLicense(date) {
      this.societyConnector.listDataLicense(moment(date).add(1, "d").format("YYYY-MM-DD")).then((response) => {
        // TODO: format in db server
        this.dataLicense = response.map((data) => {
          return {
            name_soc: data.name_soc,
            name_plyr: data.name_plyr,
            dt_expire: moment(data.dt_expire).format("DD-MM-YYYY"),
          };
        });
      });
    },
  },
};
</script>

<style></style>
